import { api } from '../../../api';
import { ApiResponse, PageResult } from '../../Utilities';
import { ERPGatewayConfigurationViewModel, ERPGatewayConfigurationSearchViewModel } from '../../ViewModels';
import { GetERPGatewayConfigurationsParams } from './Params';

export class ERPGatewayConfigurationApi {
    private route = '/ERPGatewayConfiguration';

    public getERPGatewayConfiguration = (id: number): ApiResponse<ERPGatewayConfigurationViewModel> => {
        return api().get(`${this.route}/${id}`);
    };

    public getERPGatewayConfigurations = (
        params: GetERPGatewayConfigurationsParams
    ): ApiResponse<PageResult<ERPGatewayConfigurationViewModel | ERPGatewayConfigurationSearchViewModel>> => {
        return api().get(`${this.route}`, { params });
    };

    /**
     * @deprecated Use getERPGatewayConfigurations instead
     */
    public getERPGatewayConfigurationByCompanyId = (
        companyId: number
    ): ApiResponse<PageResult<ERPGatewayConfigurationViewModel>> => {
        return this.getERPGatewayConfigurations({ companyId });
    };

    public postERPGatewayConfiguration = (
        data: ERPGatewayConfigurationViewModel
    ): ApiResponse<ERPGatewayConfigurationViewModel> => {
        return api().post(`${this.route}`, data);
    };

    public putERPGatewayConfiguration = (id: number, data: ERPGatewayConfigurationViewModel): ApiResponse<void> => {
        return api().put(`${this.route}/${id}`, data);
    };
}
